// extracted by mini-css-extract-plugin
export default {"link":"J_g70v","RibbonButton":"RUcHNr","ribbonButton":"RUcHNr","label":"yULJYL","tri":"uqIwAp","tail":"tq66vA"};